module.exports = __webpack_public_path__ + "static/media/photon.020d72ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/photon.jpg
// module id = 230
// module chunks = 2